const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths.filter((width) => width <= image["width"]).map((width) => {
    imageUrl.searchParams.set("width", width.toString());
    return `${imageUrl.href} ${width}w`;
  }).join(", ");
}

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
  newImage.loading="lazy"
  return newImage;
}

const checkSwatches = () => {
  document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
    wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
      input.addEventListener('click', (event) => {
        const primaryImage = wrapper.querySelector(".media--first");
        const secondaryImage = wrapper.querySelector(".media--second");
        const handleProduct = wrapper.dataset.product;
        
        if (event.currentTarget.checked && primaryImage) {
          wrapper.querySelector('.js-color-swatches-link').setAttribute('href', event.currentTarget.dataset.variantLink);
          if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
            wrapper.querySelector('.card__add-to-cart button[name="add"]').setAttribute('aria-disabled', false);
            if (wrapper.querySelector('.card__add-to-cart button[name="add"] > span')) {
              wrapper.querySelector('.card__add-to-cart button[name="add"] > span').classList.remove('hidden');
              wrapper.querySelector('.card__add-to-cart button[name="add"] .sold-out-message').classList.add('hidden');
            }
            wrapper.querySelector('.card__add-to-cart input[name="id"]').value = event.currentTarget.dataset.variantId;
          }
          
          const currentColor = event.currentTarget.value;

          jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function(product) {
            const variant = product.variants.filter(item => item.featured_media != null && item.options.includes(currentColor))[0];

            if (variant) {
              const newPrimaryImage = createImageElement(variant["featured_media"], primaryImage.className, primaryImage.sizes, product.title);
              
              if (newPrimaryImage.src !== primaryImage.src) {
                let flag = false;
                if (secondaryImage) {
                  const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                  const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                  if (secondaryImagePathname == newPrimaryImagePathname) {
                    primaryImage.remove();
                    secondaryImage.classList.remove('media--second');
                    secondaryImage.classList.add('media--first');
                    flag = true;
                  } 
                }
                if (flag == false) {
                  primaryImage.animate({ opacity: [1, 0] }, { duration: 200, easing: "ease-in", fill: "forwards" }).finished;
                  setTimeout(function(){
                    primaryImage.replaceWith(newPrimaryImage);
                    newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: "ease-in" });
                    if (secondaryImage) {
                      secondaryImage.remove();                                    
                    }
                  }, 200);
                }
              }
            }
          });
        }
      })
    })
  })
}

function colorSwatches() {
  checkSwatches();

  document.addEventListener('shopify:section:load', function () {
    checkSwatches();
  });
}

(function () {
colorSwatches();
})();

(function () {
  const viewerClass = "product-image-viewer";
  const openClass = "product-image-viewer-open";
  const minScale = 1;
  const maxScale = 4;
  const scaleStep = 0.5;

  let viewer = null;
  let imageNode = null;
  let counterNode = null;
  let prevButton = null;
  let nextButton = null;
  let lastActiveElement = null;
  let loadingToken = 0;
  let items = [];
  let currentIndex = 0;
  let scale = 1;
  let position = { x: 0, y: 0 };
  let dragStart = null;
  let pinchStart = null;
  let interactionMoved = false;
  const activePointers = new Map();

  const parseLargestSrc = (img) => {
    if (!img.srcset) {
      return img.currentSrc || img.src;
    }

    return img.srcset
      .split(",")
      .map((item) => {
        const parts = item.trim().split(/\s+/);
        return {
          src: parts[0],
          width: parseInt((parts[1] || "").replace("w", ""), 10) || 0,
        };
      })
      .sort((a, b) => b.width - a.width)[0]?.src || img.currentSrc || img.src;
  };

  const createViewer = () => {
    const root = document.createElement("div");
    root.className = viewerClass;
    root.setAttribute("role", "dialog");
    root.setAttribute("aria-modal", "true");
    root.setAttribute("aria-hidden", "true");
    root.innerHTML = `
      <button class="${viewerClass}__button ${viewerClass}__close" type="button" data-action="close" aria-label="Close image preview">x</button>
      <button class="${viewerClass}__button ${viewerClass}__nav ${viewerClass}__nav--prev" type="button" data-action="prev" aria-label="Previous image">&lt;</button>
      <div class="${viewerClass}__stage">
        <div class="${viewerClass}__loader" role="status" aria-label="Loading image"></div>
        <img class="${viewerClass}__image" alt="" draggable="false">
      </div>
      <button class="${viewerClass}__button ${viewerClass}__nav ${viewerClass}__nav--next" type="button" data-action="next" aria-label="Next image">&gt;</button>
      <div class="${viewerClass}__counter" aria-live="polite"></div>
    `;

    document.body.appendChild(root);
    imageNode = root.querySelector(`.${viewerClass}__image`);
    counterNode = root.querySelector(`.${viewerClass}__counter`);
    prevButton = root.querySelector('[data-action="prev"]');
    nextButton = root.querySelector('[data-action="next"]');

    root.addEventListener("click", onViewerClick);
    root.querySelector(`.${viewerClass}__stage`).addEventListener("wheel", onWheel, { passive: false });
    root.querySelector(`.${viewerClass}__stage`).addEventListener("pointerdown", onPointerDown);
    root.querySelector(`.${viewerClass}__stage`).addEventListener("dblclick", onDoubleClick);

    return root;
  };

  const getViewer = () => {
    if (!viewer) {
      viewer = createViewer();
    }

    return viewer;
  };

  const getClampedPosition = (nextPosition) => {
    if (!viewer || !imageNode) {
      return { x: 0, y: 0 };
    }

    const stage = viewer.querySelector(`.${viewerClass}__stage`);
    const maxX = Math.max(0, (imageNode.offsetWidth * scale - stage.clientWidth) / 2);
    const maxY = Math.max(0, (imageNode.offsetHeight * scale - stage.clientHeight) / 2);

    return {
      x: Math.min(maxX, Math.max(-maxX, nextPosition.x)),
      y: Math.min(maxY, Math.max(-maxY, nextPosition.y)),
    };
  };

  const updateTransform = () => {
    if (!imageNode) {
      return;
    }

    position = getClampedPosition(position);
    getViewer().dataset.zoomed = scale > minScale ? "true" : "false";
    imageNode.style.transform = `translate3d(${position.x}px, ${position.y}px, 0) scale(${scale})`;
  };

  const resetZoom = () => {
    scale = 1;
    position = { x: 0, y: 0 };
    dragStart = null;
    pinchStart = null;
    interactionMoved = false;
    activePointers.clear();
    updateTransform();
  };

  const setScale = (nextScale) => {
    scale = Math.min(maxScale, Math.max(minScale, nextScale));
    updateTransform();
  };

  const setLoading = (isLoading) => {
    getViewer().dataset.loading = isLoading ? "true" : "false";
  };

  const showImage = (index) => {
    if (!items.length) {
      return;
    }

    currentIndex = (index + items.length) % items.length;
    const item = items[currentIndex];
    const currentLoadingToken = loadingToken + 1;
    loadingToken = currentLoadingToken;

    setLoading(true);
    resetZoom();

    imageNode.onload = () => {
      if (currentLoadingToken === loadingToken) {
        setLoading(false);
      }
    };
    imageNode.onerror = imageNode.onload;
    imageNode.alt = item.alt;
    imageNode.src = item.src;
    counterNode.textContent = `${currentIndex + 1} / ${items.length}`;
    getViewer().dataset.hasGallery = items.length > 1 ? "true" : "false";
    prevButton.disabled = items.length < 2;
    nextButton.disabled = items.length < 2;

    if (imageNode.complete) {
      window.requestAnimationFrame(() => {
        if (currentLoadingToken === loadingToken) {
          setLoading(false);
        }
      });
    }
  };

  const closeViewer = () => {
    if (!viewer || !viewer.classList.contains(`${viewerClass}--open`)) {
      return;
    }

    viewer.classList.remove(`${viewerClass}--open`);
    viewer.setAttribute("aria-hidden", "true");
    document.body.classList.remove(openClass);
    loadingToken += 1;
    setLoading(false);
    resetZoom();

    if (lastActiveElement) {
      lastActiveElement.focus();
    }
  };

  const openViewer = (nextItems, index) => {
    items = nextItems;
    lastActiveElement = document.activeElement;

    const root = getViewer();
    root.classList.add(`${viewerClass}--open`);
    root.setAttribute("aria-hidden", "false");
    document.body.classList.add(openClass);
    showImage(index);
    root.querySelector('[data-action="close"]').focus();
  };

  const onViewerClick = (event) => {
    const action = event.target.closest("[data-action]")?.dataset.action;

    if (interactionMoved && !action) {
      interactionMoved = false;
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    if (event.target === viewer || event.target.classList.contains(`${viewerClass}__stage`)) {
      closeViewer();
      return;
    }

    if (!action) {
      return;
    }

    if (action === "close") closeViewer();
    if (action === "prev") showImage(currentIndex - 1);
    if (action === "next") showImage(currentIndex + 1);
  };

  const onWheel = (event) => {
    if (!viewer.classList.contains(`${viewerClass}--open`)) {
      return;
    }

    event.preventDefault();
    setScale(scale + (event.deltaY > 0 ? -scaleStep : scaleStep));
  };

  const getPinchDistance = () => {
    const pointers = [...activePointers.values()];
    return Math.hypot(pointers[0].x - pointers[1].x, pointers[0].y - pointers[1].y);
  };

  const createMediaTrigger = () => {
    const trigger = document.createElement("button");
    trigger.className = "product-image-viewer-trigger";
    trigger.type = "button";
    trigger.setAttribute("aria-label", "Open image preview");
    trigger.innerHTML = `
      <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24">
        <path d="M8 3H3v5h2V6.41l4.3 4.29 1.4-1.4L6.41 5H8V3Zm8 0v2h1.59l-4.29 4.3 1.4 1.4L19 6.41V8h2V3h-5ZM9.3 13.3 5 17.59V16H3v5h5v-2H6.41l4.29-4.3-1.4-1.4Zm5.4 0-1.4 1.4 4.29 4.3H16v2h5v-5h-2v1.59l-4.3-4.29Z"/>
      </svg>
    `;

    return trigger;
  };

  const initProductMediaTriggers = () => {
    document.querySelectorAll(".product__media-list.no-js-hidden .product__media .product-image-viewer-trigger").forEach((trigger) => {
      trigger.remove();
    });

    document.querySelectorAll(".product__media-list.no-js-hidden").forEach((mediaList) => {
      if (!mediaList.querySelector(".product__media-item .product__media img")) {
        return;
      }

      const hasTrigger = Array.from(mediaList.children).some((child) => child.classList?.contains("product-image-viewer-trigger"));
      if (!hasTrigger) {
        mediaList.appendChild(createMediaTrigger());
      }
    });
  };

  const onPointerDown = (event) => {
    activePointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
    event.currentTarget.setPointerCapture(event.pointerId);

    if (activePointers.size === 2) {
      event.preventDefault();
      dragStart = null;
      pinchStart = {
        distance: getPinchDistance(),
        scale,
      };
      return;
    }

    if (scale <= minScale) {
      return;
    }

    event.preventDefault();
    dragStart = {
      pointerId: event.pointerId,
      x: event.clientX,
      y: event.clientY,
      positionX: position.x,
      positionY: position.y,
    };
  };

  const onPointerMove = (event) => {
    if (activePointers.has(event.pointerId)) {
      activePointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
    }

    if (pinchStart && activePointers.size >= 2) {
      event.preventDefault();
      interactionMoved = true;
      setScale(pinchStart.scale * (getPinchDistance() / pinchStart.distance));
      return;
    }

    if (!dragStart || event.pointerId !== dragStart.pointerId) {
      return;
    }

    event.preventDefault();
    interactionMoved = true;
    position = getClampedPosition({
      x: dragStart.positionX + event.clientX - dragStart.x,
      y: dragStart.positionY + event.clientY - dragStart.y,
    });
    updateTransform();
  };

  const onPointerUp = (event) => {
    activePointers.delete(event.pointerId);
    if (activePointers.size < 2) {
      pinchStart = null;
    }
    if (dragStart && event.pointerId === dragStart.pointerId) {
      dragStart = null;
    }
  };

  const onDoubleClick = (event) => {
    setScale(scale > minScale ? minScale : 2.5);
  };

  const collectProductImages = (productMediaWrapper) => {
    const result = [];
    const used = new Set();

    productMediaWrapper.querySelectorAll(".product__media-list .product__media-item .product__media img").forEach((img) => {
      const src = parseLargestSrc(img);

      if (!src || used.has(src)) {
        return;
      }

      used.add(src);
      result.push({
        src,
        alt: img.alt || document.querySelector(".product__title, h1")?.textContent?.trim() || "",
        node: img,
      });
    });

    return result;
  };

  const getCurrentProductImage = (trigger) => {
    const mediaList = trigger.closest(".product__media-list");

    return mediaList?.querySelector(".product__media-item.swiper-slide-active .product__media img")
      || mediaList?.querySelector(".product__media-item.swiper-slide-visible .product__media img")
      || mediaList?.querySelector(".product__media-item .product__media img");
  };

  const onProductMediaClick = (event) => {
    const ignoredControl = event.target.closest(".product-media-modal, .product__media-sublist, .product-button-group, .product__pagination, button, input, label, select, textarea, form");
    const trigger = event.target.closest(".product-image-viewer-trigger");

    if (ignoredControl && !trigger) {
      return false;
    }

    const productMediaWrapper = trigger?.closest(".product__media-wrapper");
    const image = trigger ? getCurrentProductImage(trigger) : null;

    if (!productMediaWrapper || !image) {
      return false;
    }

    const nextItems = collectProductImages(productMediaWrapper);
    if (!nextItems.length) {
      return false;
    }

    const imageSrc = parseLargestSrc(image);
    const startIndex = Math.max(0, nextItems.findIndex((item) => item.node === image || item.src === imageSrc));

    event.preventDefault();
    event.stopPropagation();
    openViewer(nextItems, startIndex);
    return true;
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initProductMediaTriggers);
  } else {
    initProductMediaTriggers();
  }

  document.addEventListener("shopify:section:load", initProductMediaTriggers);
  document.addEventListener("click", onProductMediaClick);
  document.addEventListener("keydown", (event) => {
    if (!viewer || !viewer.classList.contains(`${viewerClass}--open`)) {
      return;
    }

    if (event.key === "Escape") closeViewer();
    if (event.key === "ArrowLeft") showImage(currentIndex - 1);
    if (event.key === "ArrowRight") showImage(currentIndex + 1);
  });
  document.addEventListener("pointermove", onPointerMove);
  document.addEventListener("pointerup", onPointerUp);
  document.addEventListener("pointercancel", onPointerUp);
})();
